import * as Yup from "yup";
import form, {
  rolesForm,
  signatureAttachmentsForm,
} from "pages/settings/user/new/schemas/form";

const {
  formField: {
    userName,
    userGroup,
    email,
    password,
    mobile,
    roles,
    emailSignOff,
    signatureAttachments,
  },
} = form;

const noValidation = Yup.object().shape({});

const validations = Yup.object().shape({
  [userName.name]: Yup.string()
    .required(userName.errorMsg)
    .max(200, userName.invalidMsg),
  [userGroup.name]: Yup.string()
    .required(userGroup.errorMsg)
    .max(200, userGroup.invalidMsg),
  [email.name]: Yup.string()
    .required(email.errorMsg)
    .max(200, email.invalidMsg)
    .email(email.invalidMsg),
  [password.name]: Yup.string()
    .required(password.errorMsg)
    .matches(
      "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#&()-\\[{}\\]:;',?/*~$^+=<>]).{8,100}$",
      password.invalidMsg
    ),
  [mobile.name]: Yup.string()
    //.required(mobile.errorMsg)
    .max(10, mobile.invalidMsg),
  [roles.name]: Yup.array().min(1, roles.min1Msg).max(20, roles.max20Msg),
  [emailSignOff.name]: Yup.string()
    .nullable()
    //.required(emailSignOff.errorMsg)
    .max(5000, emailSignOff.invalidMsg),
  [signatureAttachments.name]: Yup.array().max(
    20,
    signatureAttachments.max20Msg
  ),
});

const {
  formField: { roleName },
} = rolesForm;

const rolesValidation = Yup.object().shape({
  [roleName.name]: Yup.string()
    .nullable()
    .required(roleName.errorMsg)
    .max(200, roleName.invalidMsg),
});

const {
  formField: { signatureAttachmentFile },
} = signatureAttachmentsForm;

const signatureAttachmentsValidation = Yup.object().shape({
  [signatureAttachmentFile.name]: Yup.mixed()
    .nullable()
    .required(signatureAttachmentFile.errorMsg)
    .test(
      "fileSize",
      signatureAttachmentFile.invalidMsg,
      (value) => !value || (value && value.size <= 5 * 1024 * 1024)
    ),
});

export {
  validations as default,
  noValidation,
  rolesValidation,
  signatureAttachmentsValidation,
};
